import { isThisWeek, isToday } from '@sayyesschool/common/libs/datetime';
import AccessGuard from '@sayyesschool/frontend/components/access-guard';
import Page from '@sayyesschool/frontend/components/page';
import { Permissions } from '@sayyesschool/frontend/data/access';
import { useLessons } from '@sayyesschool/frontend/features/lessons';
import { useMaterials } from '@sayyesschool/frontend/features/materials';
import { useRequests } from '@sayyesschool/frontend/features/requests';
import { useUser } from '@sayyesschool/frontend/features/user';
import { Grid } from '@sayyesschool/frontend/ui-components';

import LessonsList from '@/components/lessons/lessons-list';
import MeetingsList from '@/components/meetings/meetings-list';
import RequestsList from '@/components/requests/requests-list';

export default function HomePage() {
    const [user] = useUser();
    const [requests] = useRequests();
    const [lessons] = useLessons();
    const [meetings] = useMaterials();

    const requestsToday = requests?.filter(request => isToday(request.createdAt));
    const lessonsToday = lessons?.filter(lesson => isToday(lesson.date)).sort((a, b) => new Date(a.date) - new Date(b.date));
    const meetingsThisWeek = meetings?.filter(meeting => isThisWeek(meeting.startDate));

    return (
        <Page id="home">
            <Page.Header title="Главная" />

            <Page.Content>
                <Grid gap="medium">
                    <AccessGuard
                        user={user}
                        permissions={Permissions.Requests}
                    >
                        <Grid.Item xs={3}>
                            <Page.Section
                                title="Новые заявки"
                                description="Сегодня"
                                compact
                            >
                                <RequestsList requests={requestsToday} />
                            </Page.Section>
                        </Grid.Item>
                    </AccessGuard>

                    <AccessGuard
                        user={user}
                        permissions={Permissions.Lessons}
                    >
                        <Grid.Item xs={3}>
                            <Page.Section
                                title="Уроки"
                                description="Сегодня"
                                compact
                            >
                                <LessonsList
                                    lessons={lessonsToday}
                                    statusIcon={false}
                                />
                            </Page.Section>
                        </Grid.Item>
                    </AccessGuard>

                    <AccessGuard
                        user={user}
                        permissions={Permissions.Meetings}
                    >
                        <Grid.Item xs={3}>
                            <Page.Section
                                title="Встречи"
                                description="Эта неделя"
                                compact
                            >
                                <MeetingsList meetings={meetingsThisWeek} />
                            </Page.Section>
                        </Grid.Item>
                    </AccessGuard>
                </Grid>
            </Page.Content>
        </Page>
    );
}